module.exports = __webpack_public_path__ + "static/media/IT.8cbfed40.svg";